import { render, staticRenderFns } from "./WelcomePage.vue?vue&type=template&id=925b447a&scoped=true"
import script from "./WelcomePage.vue?vue&type=script&lang=js"
export * from "./WelcomePage.vue?vue&type=script&lang=js"
import style0 from "./WelcomePage.vue?vue&type=style&index=0&id=925b447a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925b447a",
  null
  
)

export default component.exports